import { getAppConfig } from "../config";
import { Configuration } from "./api";
import { store, type RootState } from "../store";
import { authIsEnabled } from "../utils/auth";

const appConfig = getAppConfig();

export function useApiConfiguration() {
  return new Configuration({
    basePath: appConfig.apiUrl,
    ...(authIsEnabled() && {
      accessToken: async () => {
        const { auth: { user } } = store.getState()

        if (user && user.access_token) {
          return user.access_token;
        }
        throw new Error("User is not authenticated or access token is not available.");
      }
    }),
  });
}
